/* Auto-built from oxyMarketplace.json — every function of the contract is covered. */
import { fmt } from "../shared/format";

export const readFunctions = [
  {
    name: "adminWallet",
    title: "Admin Wallet",
    description: "Read `adminWallet` from the contract",
    icon: "🔹",
    category: "Basic Info",
    inputs: [],
  },
  {
    name: "autoTradeFee",
    title: "Auto Trade Fee",
    description: "Auto-trade fee exactly as stored by the contract (raw units).",
    icon: "💲",
    category: "Trading",
    inputs: [],
  },
  {
    name: "autoTradeFeeReceiver",
    title: "Auto Trade Fee Receiver",
    description: "Read `autoTradeFeeReceiver` from the contract",
    icon: "💲",
    category: "Receivers & Wallets",
    inputs: [],
  },
  {
    name: "botById",
    title: "Bot By ID",
    description: "Read `botById` from the contract",
    icon: "🤖",
    category: "Bots",
    inputs: [
      { name: "arg0", type: "uint256", label: "Index", placeholder: "Enter value", required: true },
    ],
  },
  {
    name: "botCount",
    title: "Bot Count",
    description: "Read `botCount` from the contract",
    icon: "🤖",
    category: "Bots",
    inputs: [],
  },
  {
    name: "botInfo",
    title: "Bot Info",
    description: "Read `botInfo` from the contract",
    icon: "🤖",
    category: "Bots",
    inputs: [
      { name: "arg0", type: "address", label: "Address", placeholder: "0x…", required: true },
    ],
    formatOutput: (v) => [
      `Last Time Stamp: ${fmt.time(v.lastTimeStamp ?? v[0])}`,
      `Bot ID: ${v.botId ?? v[1]}`,
      `Is Enable: ${fmt.bool(v.isEnable ?? v[2])}`,
    ].join("\n"),
  },
  {
    name: "botTimeDuration",
    title: "Bot Time Duration",
    description: "Read `botTimeDuration` from the contract",
    icon: "🤖",
    category: "Bots",
    inputs: [],
    formatOutput: (v) => fmt.duration(v),
  },
  {
    name: "buringIncomePercent",
    title: "Buring Income Percent",
    description: "Read `buringIncomePercent` from the contract",
    icon: "💰",
    category: "Income & Percentages",
    inputs: [],
    formatOutput: (v) => fmt.percent(v),
  },
  {
    name: "buyCount",
    title: "Buy Count",
    description: "Read `buyCount` from the contract",
    icon: "🛒",
    category: "Trading",
    inputs: [],
  },
  {
    name: "buyingIncomePercent",
    title: "Buying Income Percent",
    description: "Read `buyingIncomePercent` from the contract",
    icon: "🛒",
    category: "Income & Percentages",
    inputs: [],
    formatOutput: (v) => fmt.percent(v),
  },
  {
    name: "checkQueue",
    title: "Check Queue",
    description: "Read `checkQueue` from the contract",
    icon: "📋",
    category: "Queue",
    inputs: [
      { name: "tradeId", type: "uint256", label: "Trade ID", placeholder: "Enter trade id", required: true },
    ],
    formatOutput: (v) => fmt.bool(v),
  },
  {
    name: "getBotAddress",
    title: "Get Bot Address",
    description: "Read `getBotAddress` from the contract",
    icon: "🤖",
    category: "Bots",
    inputs: [
      { name: "botId", type: "uint256", label: "Bot ID", placeholder: "Enter bot id", required: true },
    ],
  },
  {
    name: "getBotId",
    title: "Get Bot ID",
    description: "Read `getBotId` from the contract",
    icon: "🤖",
    category: "Bots",
    inputs: [
      { name: "wallet", type: "address", label: "Wallet", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "getEligibleTradeBots",
    title: "Get Eligible Trade Bots",
    description: "Read `getEligibleTradeBots` from the contract",
    icon: "🤖",
    category: "Bots",
    inputs: [],
    formatOutput: (v) => fmt.list(v),
  },
  {
    name: "getOxyPrice",
    title: "Get OXY Price",
    description: "Read `getOxyPrice` from the contract",
    icon: "💲",
    category: "Economics",
    inputs: [
      { name: "usdtAmount", type: "uint256", label: "USDT Amount", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
    formatOutput: (v) => fmt.amount(v),
  },
  {
    name: "getTradeDetails",
    title: "Get Trade Details",
    description: "Base price, owner, sale flag and timestamps of a trade.",
    icon: "🛒",
    category: "Trading",
    inputs: [
      { name: "tradeId", type: "uint256", label: "Trade ID", placeholder: "Enter trade id", required: true },
    ],
    formatOutput: (v) => [
      `Base Price: ${fmt.amount(v.basePrice ?? v[0])}`,
      `Curr Trade Owner: ${v.currTradeOwner ?? v[1]}`,
      `Is Sale: ${fmt.bool(v.isSale ?? v[2])}`,
      `Buy Time Stamp: ${fmt.time(v.buyTimeStamp ?? v[3])}`,
      `Sale Time Stamp: ${fmt.time(v.saleTimeStamp ?? v[4])}`,
    ].join("\n"),
  },
  {
    key: "getTradeQueue__2",
    signature: "getTradeQueue(uint256,uint256)",
    name: "getTradeQueue",
    title: "Get Trade Queue",
    description: "Read `getTradeQueue` from the contract",
    icon: "📋",
    category: "Queue",
    inputs: [
      { name: "startIndex", type: "uint256", label: "Start Index", placeholder: "Enter start index", required: true },
      { name: "endIndex", type: "uint256", label: "End Index", placeholder: "Enter end index", required: true },
    ],
    formatOutput: (v) => fmt.list(v),
  },
  {
    key: "getTradeQueue__0",
    signature: "getTradeQueue()",
    name: "getTradeQueue",
    title: "Get Trade Queue",
    description: "Read `getTradeQueue` from the contract",
    icon: "📋",
    category: "Queue",
    inputs: [],
    formatOutput: (v) => fmt.list(v),
  },
  {
    name: "getUserAllTrades",
    title: "Get User All Trades",
    description: "Read `getUserAllTrades` from the contract",
    icon: "👤",
    category: "User Info",
    inputs: [
      { name: "account", type: "address", label: "Account", placeholder: "0x…", required: true },
    ],
    formatOutput: (v) => fmt.list(v),
  },
  {
    name: "getUserHoldLength",
    title: "Get User Hold Length",
    description: "Read `getUserHoldLength` from the contract",
    icon: "👤",
    category: "User Info",
    inputs: [
      { name: "account", type: "address", label: "Account", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "getUserNextSale",
    title: "Get User Next Sale",
    description: "Timestamp when the account may sell next.",
    icon: "👤",
    category: "User Info",
    inputs: [
      { name: "account", type: "address", label: "Account", placeholder: "0x…", required: true },
    ],
    formatOutput: (v) => fmt.time(v),
  },
  {
    name: "getUserOwnedTradeAt",
    title: "Get User Owned Trade At",
    description: "Read `getUserOwnedTradeAt` from the contract",
    icon: "👤",
    category: "User Info",
    inputs: [
      { name: "account", type: "address", label: "Account", placeholder: "0x…", required: true },
      { name: "index", type: "uint256", label: "Index", placeholder: "Enter index", required: true },
    ],
  },
  {
    name: "getUserOwnedTradeContains",
    title: "Get User Owned Trade Contains",
    description: "Read `getUserOwnedTradeContains` from the contract",
    icon: "👤",
    category: "User Info",
    inputs: [
      { name: "account", type: "address", label: "Account", placeholder: "0x…", required: true },
      { name: "tradeId", type: "uint256", label: "Trade ID", placeholder: "Enter trade id", required: true },
    ],
    formatOutput: (v) => fmt.bool(v),
  },
  {
    name: "getUserOwnedTradeLength",
    title: "Get User Owned Trade Length",
    description: "Read `getUserOwnedTradeLength` from the contract",
    icon: "👤",
    category: "User Info",
    inputs: [
      { name: "account", type: "address", label: "Account", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "getUserTradeQueue",
    title: "Get User Trade Queue",
    description: "Read `getUserTradeQueue` from the contract",
    icon: "📋",
    category: "Queue",
    inputs: [
      { name: "account", type: "address", label: "Account", placeholder: "0x…", required: true },
    ],
    formatOutput: (v) => fmt.list(v),
  },
  {
    name: "globalPeriod",
    title: "Global Period",
    description: "Read `globalPeriod` from the contract",
    icon: "⏱️",
    category: "Timing",
    inputs: [],
    formatOutput: (v) => fmt.duration(v),
  },
  {
    name: "isAutoTradeFee",
    title: "Is Auto Trade Fee",
    description: "Read `isAutoTradeFee` from the contract",
    icon: "💲",
    category: "User Info",
    inputs: [],
    formatOutput: (v) => fmt.bool(v),
  },
  {
    name: "lastPurchaseAt",
    title: "Last Purchase At",
    description: "Read `lastPurchaseAt` from the contract",
    icon: "🔹",
    category: "Other",
    inputs: [
      { name: "arg0", type: "address", label: "Address", placeholder: "0x…", required: true },
    ],
    formatOutput: (v) => fmt.time(v),
  },
  {
    name: "levelIncomePercent",
    title: "Level Income Percent",
    description: "Read `levelIncomePercent` from the contract",
    icon: "💰",
    category: "Income & Percentages",
    inputs: [],
    formatOutput: (v) => fmt.percent(v),
  },
  {
    name: "lpIncomePercent",
    title: "LP Income Percent",
    description: "Read `lpIncomePercent` from the contract",
    icon: "💧",
    category: "Income & Percentages",
    inputs: [],
    formatOutput: (v) => fmt.percent(v),
  },
  {
    name: "lpReward",
    title: "LP Reward",
    description: "Read `lpReward` from the contract",
    icon: "💧",
    category: "Linked Contracts",
    inputs: [],
  },
  {
    name: "maxSalePrice",
    title: "Max Sale Price",
    description: "Read `maxSalePrice` from the contract",
    icon: "💲",
    category: "Trading",
    inputs: [],
    formatOutput: (v) => fmt.amount(v),
  },
  {
    name: "maxTradeSupply",
    title: "Max Trade Supply",
    description: "Maximum number of trade IDs that can ever exist (a count).",
    icon: "📈",
    category: "Trading",
    inputs: [],
  },
  {
    name: "oxyToken",
    title: "OXY Token",
    description: "Read `oxyToken` from the contract",
    icon: "🪙",
    category: "Basic Info",
    inputs: [],
  },
  {
    name: "nftMatrixContract",
    title: "NFT Matrix Contract",
    description: "Read `nftMatrixContract` from the contract",
    icon: "🌳",
    category: "Linked Contracts",
    inputs: [],
  },
  {
    name: "nftReward",
    title: "NFT Reward",
    description: "Read `nftReward` from the contract",
    icon: "💰",
    category: "Linked Contracts",
    inputs: [],
  },
  {
    name: "owner",
    title: "Owner",
    description: "Read `owner` from the contract",
    icon: "👑",
    category: "Basic Info",
    inputs: [],
  },
  {
    name: "pair",
    title: "Pair",
    description: "Read `pair` from the contract",
    icon: "🔁",
    category: "Basic Info",
    inputs: [],
  },
  {
    name: "paused",
    title: "Paused",
    description: "Read `paused` from the contract",
    icon: "⏸️",
    category: "Basic Info",
    inputs: [],
    formatOutput: (v) => fmt.bool(v),
  },
  {
    name: "platformIncomePercent",
    title: "Platform Income Percent",
    description: "Read `platformIncomePercent` from the contract",
    icon: "💰",
    category: "Income & Percentages",
    inputs: [],
    formatOutput: (v) => fmt.percent(v),
  },
  {
    name: "platformIncomeReceiver1",
    title: "Platform Income Receiver1",
    description: "Read `platformIncomeReceiver1` from the contract",
    icon: "💰",
    category: "Receivers & Wallets",
    inputs: [],
  },
  {
    name: "platformIncomeReceiver2",
    title: "Platform Income Receiver2",
    description: "Read `platformIncomeReceiver2` from the contract",
    icon: "💰",
    category: "Receivers & Wallets",
    inputs: [],
  },
  {
    name: "platformIncomeReceiver3",
    title: "Platform Income Receiver3",
    description: "Read `platformIncomeReceiver3` from the contract",
    icon: "💰",
    category: "Receivers & Wallets",
    inputs: [],
  },
  {
    name: "platformIncomeReceiver4",
    title: "Platform Income Receiver4",
    description: "Read `platformIncomeReceiver4` from the contract",
    icon: "💰",
    category: "Receivers & Wallets",
    inputs: [],
  },
  {
    name: "platformRewardReceiver",
    title: "Platform Reward Receiver",
    description: "Read `platformRewardReceiver` from the contract",
    icon: "💰",
    category: "Receivers & Wallets",
    inputs: [],
  },
  {
    name: "queueRequire",
    title: "Queue Require",
    description: "Queue length required before a sale can settle (a count).",
    icon: "📋",
    category: "Queue",
    inputs: [],
  },
  {
    name: "router",
    title: "Router",
    description: "Read `router` from the contract",
    icon: "🔁",
    category: "Basic Info",
    inputs: [],
  },
  {
    name: "sellPercent",
    title: "Sell Percent",
    description: "Read `sellPercent` from the contract",
    icon: "💱",
    category: "Income & Percentages",
    inputs: [],
    formatOutput: (v) => fmt.percent(v),
  },
  {
    name: "stakingIncomePercent",
    title: "Staking Income Percent",
    description: "Read `stakingIncomePercent` from the contract",
    icon: "🔒",
    category: "Income & Percentages",
    inputs: [],
    formatOutput: (v) => fmt.percent(v),
  },
  {
    name: "stakingReward",
    title: "Staking Reward",
    description: "Read `stakingReward` from the contract",
    icon: "🔒",
    category: "Linked Contracts",
    inputs: [],
  },
  {
    name: "topBuyerIncomePercent",
    title: "Top Buyer Income Percent",
    description: "Read `topBuyerIncomePercent` from the contract",
    icon: "💰",
    category: "Income & Percentages",
    inputs: [],
    formatOutput: (v) => fmt.percent(v),
  },
  {
    name: "topTraderReward",
    title: "Top Trader Reward",
    description: "Read `topTraderReward` from the contract",
    icon: "💰",
    category: "Linked Contracts",
    inputs: [],
  },
  {
    name: "totalTradeIds",
    title: "Total Trade IDS",
    description: "Read `totalTradeIds` from the contract",
    icon: "📈",
    category: "Trading",
    inputs: [],
  },
  {
    name: "tradeBasePrice",
    title: "Trade Base Price",
    description: "Read `tradeBasePrice` from the contract",
    icon: "💲",
    category: "Trading",
    inputs: [],
    formatOutput: (v) => fmt.amount(v),
  },
  {
    name: "tradeBurnBasePrice",
    title: "Trade Burn Base Price",
    description: "Read `tradeBurnBasePrice` from the contract",
    icon: "🔥",
    category: "Trading",
    inputs: [],
    formatOutput: (v) => fmt.amount(v),
  },
  {
    name: "tradeDeadDuration",
    title: "Trade Dead Duration",
    description: "Read `tradeDeadDuration` from the contract",
    icon: "⏱️",
    category: "Trading",
    inputs: [],
    formatOutput: (v) => fmt.duration(v),
  },
  {
    name: "tradeInfo",
    title: "Trade Info",
    description: "Read `tradeInfo` from the contract",
    icon: "🛒",
    category: "Trading",
    inputs: [
      { name: "arg0", type: "uint256", label: "Index", placeholder: "Enter value", required: true },
    ],
    formatOutput: (v) => [
      `Base Price: ${fmt.amount(v.basePrice ?? v[0])}`,
      `Trade Owner: ${v.tradeOwner ?? v[1]}`,
      `Last Sale Time Stamp: ${fmt.time(v.lastSaleTimeStamp ?? v[2])}`,
      `Is Sale: ${fmt.bool(v.isSale ?? v[3])}`,
    ].join("\n"),
  },
  {
    name: "tradeOwner",
    title: "Trade Owner",
    description: "Read `tradeOwner` from the contract",
    icon: "👑",
    category: "Trading",
    inputs: [
      { name: "arg0", type: "uint256", label: "Index", placeholder: "Enter value", required: true },
    ],
  },
  {
    name: "tradeOwnerIncomePercent",
    title: "Trade Owner Income Percent",
    description: "Read `tradeOwnerIncomePercent` from the contract",
    icon: "👑",
    category: "Income & Percentages",
    inputs: [],
    formatOutput: (v) => fmt.percent(v),
  },
  {
    name: "tradeQueue",
    title: "Trade Queue",
    description: "Read `tradeQueue` from the contract",
    icon: "📋",
    category: "Queue",
    inputs: [
      { name: "arg0", type: "uint256", label: "Index", placeholder: "Enter value", required: true },
    ],
  },
  {
    name: "tradeQueueDeleted",
    title: "Trade Queue Deleted",
    description: "Read `tradeQueueDeleted` from the contract",
    icon: "📋",
    category: "Queue",
    inputs: [
      { name: "arg0", type: "uint256", label: "Index", placeholder: "Enter value", required: true },
    ],
    formatOutput: (v) => fmt.bool(v),
  },
  {
    name: "tradeQueueEnd",
    title: "Trade Queue End",
    description: "Read `tradeQueueEnd` from the contract",
    icon: "📋",
    category: "Queue",
    inputs: [],
  },
  {
    name: "tradeQueueIndex",
    title: "Trade Queue Index",
    description: "Read `tradeQueueIndex` from the contract",
    icon: "📋",
    category: "Queue",
    inputs: [
      { name: "arg0", type: "uint256", label: "Index", placeholder: "Enter value", required: true },
    ],
  },
  {
    name: "tradeQueueIsEmpty",
    title: "Trade Queue Is Empty",
    description: "Read `tradeQueueIsEmpty` from the contract",
    icon: "📋",
    category: "Queue",
    inputs: [],
    formatOutput: (v) => fmt.bool(v),
  },
  {
    name: "tradeQueueLength",
    title: "Trade Queue Length",
    description: "Read `tradeQueueLength` from the contract",
    icon: "📋",
    category: "Queue",
    inputs: [],
  },
  {
    name: "tradeQueueStart",
    title: "Trade Queue Start",
    description: "Read `tradeQueueStart` from the contract",
    icon: "📋",
    category: "Queue",
    inputs: [],
  },
  {
    name: "tradeTimeInfo",
    title: "Trade Time Info",
    description: "Read `tradeTimeInfo` from the contract",
    icon: "⏱️",
    category: "Trading",
    inputs: [
      { name: "arg0", type: "uint256", label: "Index", placeholder: "Enter value", required: true },
    ],
    formatOutput: (v) => [
      `Buy Time Stamp: ${fmt.time(v.buyTimeStamp ?? v[0])}`,
      `Sale Time Stamp: ${fmt.time(v.saleTimeStamp ?? v[1])}`,
    ].join("\n"),
  },
  {
    name: "usdtToken",
    title: "USDT Token",
    description: "Read `usdtToken` from the contract",
    icon: "🪙",
    category: "Basic Info",
    inputs: [],
  },
  {
    name: "userDayPurchase",
    title: "User Day Purchase",
    description: "Read `userDayPurchase` from the contract",
    icon: "👤",
    category: "User Info",
    inputs: [
      { name: "arg0", type: "address", label: "Address", placeholder: "0x…", required: true },
      { name: "arg1", type: "uint256", label: "Index", placeholder: "Enter value", required: true },
    ],
    formatOutput: (v) => fmt.amount(v),
  },
  {
    name: "userProfiles",
    title: "User Profiles",
    description: "Read `userProfiles` from the contract",
    icon: "👤",
    category: "User Info",
    inputs: [
      { name: "arg0", type: "address", label: "Address", placeholder: "0x…", required: true },
    ],
    formatOutput: (v) => [
      `User Hold Start: ${v.userHoldStart ?? v[0]}`,
      `User Hold End: ${v.userHoldEnd ?? v[1]}`,
      `User Last Cycle: ${v.userLastCycle ?? v[2]}`,
      `User Last Draw: ${fmt.time(v.userLastDraw ?? v[3])}`,
      `Last Purchase Timestamp: ${fmt.time(v.lastPurchaseTimestamp ?? v[4])}`,
      `Is Exclude Condition: ${fmt.bool(v.isExcludeCondition ?? v[5])}`,
      `Is Blocked: ${fmt.bool(v.isBlocked ?? v[6])}`,
    ].join("\n"),
  },
  {
    name: "userTradeQueue",
    title: "User Trade Queue",
    description: "Read `userTradeQueue` from the contract",
    icon: "📋",
    category: "Queue",
    inputs: [
      { name: "arg0", type: "address", label: "Address", placeholder: "0x…", required: true },
      { name: "arg1", type: "uint256", label: "Index", placeholder: "Enter value", required: true },
    ],
  },
];

export const writeFunctions = [
  {
    name: "burnTradeId",
    title: "Burn Trade",
    description: "Burn one of your own trade IDs.",
    icon: "🔥",
    category: "User Actions",
    inputs: [
      { name: "tradeId", type: "uint256", label: "Trade ID", placeholder: "Enter trade id", required: true },
    ],
  },
  {
    name: "buyTrade",
    title: "Buy Trade",
    description: "Buy the next trade slot from the marketplace at the current base price.",
    icon: "🛒",
    category: "User Actions",
    inputs: [],
    payment: [
      { token: "USDT", amount: ({ contract }) => contract.methods.tradeBasePrice().call(), optional: true },
      {
        token: "OXY",
        optional: true,
        amount: async ({ contract }) => {
          const base = await contract.methods.tradeBasePrice().call();
          return contract.methods.getOxyPrice(base).call();
        },
      },
    ],
  },
  {
    name: "enableAutoTrade",
    title: "Enable Auto Trade",
    description: "Register your wallet as an auto-trade bot.",
    icon: "🛒",
    category: "User Actions",
    inputs: [],
    payment: [
      {
        token: "USDT",
        optional: true,
        amount: async ({ contract }) => {
          const enabled = await contract.methods.isAutoTradeFee().call();
          return enabled ? contract.methods.autoTradeFee().call() : "0";
        },
      },
    ],
  },
  {
    name: "placeOrder",
    title: "Place Order (List for Sale)",
    description: "Put one of your trade IDs into the sale queue.",
    icon: "🔹",
    category: "User Actions",
    inputs: [
      { name: "tradeId", type: "uint256", label: "Trade ID", placeholder: "Enter trade id", required: true, hint: "Must be a trade you currently own." },
    ],
  },
];

export const adminFunctions = [
  {
    name: "autoTradeBatch",
    title: "Auto Trade Batch",
    description: "Call `autoTradeBatch` on the contract",
    icon: "🛒",
    category: "Admin Operations",
    inputs: [
      { name: "tradeIds", type: "uint256[]", label: "Trade IDS", placeholder: "value1, value2, …", required: true, isArray: true },
      { name: "bots", type: "address[]", label: "Bots", placeholder: "value1, value2, …", required: true, isArray: true },
    ],
    formatOutput: (v) => fmt.list(v),
  },
  {
    name: "bulkBurnTradeId",
    title: "Bulk Burn Trade ID",
    description: "Call `bulkBurnTradeId` on the contract",
    icon: "🔥",
    category: "Admin Operations",
    ownerOnly: true,
    inputs: [
      { name: "tradeIds", type: "uint256[]", label: "Trade IDS", placeholder: "value1, value2, …", required: true, isArray: true },
    ],
  },
  {
    name: "burnExpiredTrade",
    title: "Burn Expired Trade",
    description: "Call `burnExpiredTrade` on the contract",
    icon: "🔥",
    category: "Admin Operations",
    inputs: [
      { name: "tradeId", type: "uint256", label: "Trade ID", placeholder: "Enter trade id", required: true },
    ],
  },
  {
    name: "burnTradeFromOwner",
    title: "Burn Trade From Owner",
    description: "Call `burnTradeFromOwner` on the contract",
    icon: "👑",
    category: "Admin Operations",
    ownerOnly: true,
    inputs: [
      { name: "tradeId", type: "uint256", label: "Trade ID", placeholder: "Enter trade id", required: true },
    ],
  },
  {
    name: "burnTradeReward",
    title: "Burn Trade Reward",
    description: "Call `burnTradeReward` on the contract",
    icon: "🔥",
    category: "Admin Operations",
    inputs: [
      { name: "tradeId", type: "uint256", label: "Trade ID", placeholder: "Enter trade id", required: true },
    ],
    formatOutput: (v) => fmt.bool(v),
  },
  {
    name: "initialize",
    title: "Initialize",
    description: "Call `initialize` on the contract",
    icon: "⚙️",
    category: "Admin Control",
    ownerOnly: true,
    inputs: [
      { name: "initialOwner", type: "address", label: "Initial Owner", placeholder: "0x…", required: true },
      { name: "oxyTokenAddress", type: "address", label: "OXY Token Address", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "newSetup",
    title: "New Setup",
    description: "Call `newSetup` on the contract",
    icon: "⚙️",
    category: "Admin Control",
    ownerOnly: true,
    inputs: [],
  },
  {
    name: "pause",
    title: "Pause",
    description: "Call `pause` on the contract",
    icon: "⏸️",
    category: "Admin Control",
    ownerOnly: true,
    inputs: [],
  },
  {
    name: "recoverErc20",
    title: "Recover ERC20",
    description: "Call `recoverErc20` on the contract",
    icon: "♻️",
    category: "Admin Recovery",
    ownerOnly: true,
    inputs: [
      { name: "erc20Token", type: "address", label: "ERC20 Token", placeholder: "0x…", required: true },
      { name: "amount", type: "uint256", label: "Amount", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
  },
  {
    name: "recoverEth",
    title: "Recover ETH",
    description: "Call `recoverEth` on the contract",
    icon: "♻️",
    category: "Admin Recovery",
    ownerOnly: true,
    inputs: [
      { name: "amount", type: "uint256", label: "Amount", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
  },
  {
    name: "renounceOwnership",
    title: "Renounce Ownership",
    description: "Call `renounceOwnership` on the contract",
    icon: "👑",
    category: "Admin Control",
    ownerOnly: true,
    inputs: [],
  },
  {
    name: "setAutoTradeFee",
    title: "Set Auto Trade Fee",
    description: "Call `setAutoTradeFee` on the contract",
    icon: "💲",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newFee", type: "uint256", label: "New Fee", placeholder: "Enter new fee", required: true },
    ],
  },
  {
    name: "setAutoTradeFeeEnable",
    title: "Set Auto Trade Fee Enable",
    description: "Call `setAutoTradeFeeEnable` on the contract",
    icon: "💲",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "status", type: "bool", label: "Status", placeholder: "true / false", required: true },
    ],
  },
  {
    name: "setAutoTradeFeeReceiver",
    title: "Set Auto Trade Fee Receiver",
    description: "Call `setAutoTradeFeeReceiver` on the contract",
    icon: "💲",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newWallet", type: "address", label: "New Wallet", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "setBotTimeDuration",
    title: "Set Bot Time Duration",
    description: "Call `setBotTimeDuration` on the contract",
    icon: "🤖",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newBotTimeDuration", type: "uint256", label: "New Bot Time Duration", placeholder: "Enter new bot time duration", required: true },
    ],
  },
  {
    name: "setGlobalPeriod",
    title: "Set Global Period",
    description: "Call `setGlobalPeriod` on the contract",
    icon: "⏱️",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newGlobalPeriod", type: "uint256", label: "New Global Period", placeholder: "Enter new global period", required: true },
    ],
  },
  {
    name: "setLastPurchaseAt",
    title: "Set Last Purchase At",
    description: "Call `setLastPurchaseAt` on the contract",
    icon: "⚙️",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "account", type: "address", label: "Account", placeholder: "0x…", required: true },
      { name: "newPeriod", type: "uint256", label: "New Period", placeholder: "Enter new period", required: true },
    ],
  },
  {
    name: "setLpRewardContract",
    title: "Set LP Reward Contract",
    description: "Call `setLpRewardContract` on the contract",
    icon: "💧",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newLpReward", type: "address", label: "New LP Reward", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "setMaxSalePrice",
    title: "Set Max Sale Price",
    description: "Call `setMaxSalePrice` on the contract",
    icon: "💲",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newMaxSalePrice", type: "uint256", label: "New Max Sale Price", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
  },
  {
    name: "setMaxTradeSupply",
    title: "Set Max Trade Supply",
    description: "Call `setMaxTradeSupply` on the contract",
    icon: "📈",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newSupply", type: "uint256", label: "New Supply", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
  },
  {
    name: "setOxyToken",
    title: "Set OXY Token",
    description: "Call `setOxyToken` on the contract",
    icon: "🪙",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newOxyToken", type: "address", label: "New OXY Token", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "setNftMatrixContract",
    title: "Set NFT Matrix Contract",
    description: "Call `setNftMatrixContract` on the contract",
    icon: "🌳",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newNftMatrix", type: "address", label: "New NFT Matrix", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "setNftRewardContract",
    title: "Set NFT Reward Contract",
    description: "Call `setNftRewardContract` on the contract",
    icon: "💰",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newNftReward", type: "address", label: "New NFT Reward", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "setPlatformIncomeReceivers",
    title: "Set Platform Income Receivers",
    description: "Call `setPlatformIncomeReceivers` on the contract",
    icon: "💰",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newPlatformIncomeReceiver1", type: "address", label: "New Platform Income Receiver1", placeholder: "0x…", required: true },
      { name: "newPlatformIncomeReceiver2", type: "address", label: "New Platform Income Receiver2", placeholder: "0x…", required: true },
      { name: "newPlatformIncomeReceiver3", type: "address", label: "New Platform Income Receiver3", placeholder: "0x…", required: true },
      { name: "newPlatformIncomeReceiver4", type: "address", label: "New Platform Income Receiver4", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "setPlatformRewardReceiver",
    title: "Set Platform Reward Receiver",
    description: "Call `setPlatformRewardReceiver` on the contract",
    icon: "💰",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newPlatformRewardReceiver", type: "address", label: "New Platform Reward Receiver", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "setQueueRequire",
    title: "Set Queue Require",
    description: "Call `setQueueRequire` on the contract",
    icon: "📋",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newQueueRequire", type: "uint256", label: "New Queue Require", placeholder: "Enter new queue require", required: true },
    ],
  },
  {
    name: "setRouterAndPair",
    title: "Set Router And Pair",
    description: "Call `setRouterAndPair` on the contract",
    icon: "🔁",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newRouter", type: "address", label: "New Router", placeholder: "0x…", required: true },
      { name: "newPair", type: "address", label: "New Pair", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "setSaleIncomePercent",
    title: "Set Sale Income Percent",
    description: "Call `setSaleIncomePercent` on the contract",
    icon: "💰",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newTradeOwnerIncomePercent", type: "uint256", label: "New Trade Owner Income Percent", placeholder: "Enter new trade owner income percent", required: true },
      { name: "newLevelIncomePercent", type: "uint256", label: "New Level Income Percent", placeholder: "Enter new level income percent", required: true },
      { name: "newBuringIncomePercent", type: "uint256", label: "New Buring Income Percent", placeholder: "Enter new buring income percent", required: true },
      { name: "newBuyingIncomePercent", type: "uint256", label: "New Buying Income Percent", placeholder: "Enter new buying income percent", required: true },
      { name: "newPlatformIncomePercent", type: "uint256", label: "New Platform Income Percent", placeholder: "Enter new platform income percent", required: true },
      { name: "newStakingIncomePercent", type: "uint256", label: "New Staking Income Percent", placeholder: "Enter new staking income percent", required: true },
      { name: "newTopBuyerIncomePercent", type: "uint256", label: "New Top Buyer Income Percent", placeholder: "Enter new top buyer income percent", required: true },
      { name: "newLpIncomePercent", type: "uint256", label: "New LP Income Percent", placeholder: "Enter new lp income percent", required: true },
    ],
  },
  {
    name: "setSellPercent",
    title: "Set Sell Percent",
    description: "Call `setSellPercent` on the contract",
    icon: "📊",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newSellPercent", type: "uint256", label: "New Sell Percent", placeholder: "Enter new sell percent", required: true },
    ],
  },
  {
    name: "setStakingRewardContract",
    title: "Set Staking Reward Contract",
    description: "Call `setStakingRewardContract` on the contract",
    icon: "🔒",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newStakingReward", type: "address", label: "New Staking Reward", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "setTokenApproveMax",
    title: "Set Token Approve Max",
    description: "Call `setTokenApproveMax` on the contract",
    icon: "🪙",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [],
  },
  {
    name: "setTopTraderRewardContract",
    title: "Set Top Trader Reward Contract",
    description: "Call `setTopTraderRewardContract` on the contract",
    icon: "💰",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newTopTraderReward", type: "address", label: "New Top Trader Reward", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "setTradeBasePrice",
    title: "Set Trade Base Price",
    description: "Call `setTradeBasePrice` on the contract",
    icon: "💲",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newPrice", type: "uint256", label: "New Price", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
  },
  {
    name: "setTradeBurnBasePrice",
    title: "Set Trade Burn Base Price",
    description: "Call `setTradeBurnBasePrice` on the contract",
    icon: "🔥",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newTradeBurnBasePrice", type: "uint256", label: "New Trade Burn Base Price", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
  },
  {
    name: "setTradeDeadDuration",
    title: "Set Trade Dead Duration",
    description: "Call `setTradeDeadDuration` on the contract",
    icon: "⏱️",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newTradeDeadDuration", type: "uint256", label: "New Trade Dead Duration", placeholder: "Enter new trade dead duration", required: true },
    ],
  },
  {
    name: "setUsdtToken",
    title: "Set USDT Token",
    description: "Call `setUsdtToken` on the contract",
    icon: "🪙",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newUsdtToken", type: "address", label: "New USDT Token", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "setUserBlockRewardCondition",
    title: "Set User Block Reward Condition",
    description: "Call `setUserBlockRewardCondition` on the contract",
    icon: "🚫",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "userAccount", type: "address", label: "User Account", placeholder: "0x…", required: true },
      { name: "status", type: "bool", label: "Status", placeholder: "true / false", required: true },
    ],
  },
  {
    name: "setUserExcludeRewardCondition",
    title: "Set User Exclude Reward Condition",
    description: "Call `setUserExcludeRewardCondition` on the contract",
    icon: "🚫",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "userAccount", type: "address", label: "User Account", placeholder: "0x…", required: true },
      { name: "status", type: "bool", label: "Status", placeholder: "true / false", required: true },
    ],
  },
  {
    name: "transferOwnership",
    title: "Transfer Ownership",
    description: "Call `transferOwnership` on the contract",
    icon: "👑",
    category: "Admin Control",
    ownerOnly: true,
    inputs: [
      { name: "newOwner", type: "address", label: "New Owner", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "unpause",
    title: "Unpause",
    description: "Call `unpause` on the contract",
    icon: "▶️",
    category: "Admin Control",
    ownerOnly: true,
    allowWhilePaused: true,
    inputs: [],
  },
];

const marketplaceFunctions = { readFunctions, writeFunctions, adminFunctions };
export default marketplaceFunctions;
